import { withLayoutProps } from '@/utils/withLayoutProps';

import { StyledParagraph } from './styles';

import type { ParagraphSizeVariant } from './styles';
import type { ThemeColor } from '@/styles/theme';
import type { HTMLAttributes } from 'react';

interface HTMLParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  dangerousHTML: string;
  size?: ParagraphSizeVariant;
  color?: ThemeColor;
  weight?: 400 | 500 | 600 | 700;
  textAlign?: 'left' | 'center' | 'right';
  // Enable flexbox alignment for (vertically) centering text with icons or other elements
  flexAlignCenter?: boolean;
}

const HTMLParagraph = withLayoutProps(
  ({
    size = 'md',
    color = 'bodyTextColor',
    weight = 500,
    textAlign = 'left',
    flexAlignCenter = false,
    children,
    dangerousHTML,
    ...props
  }: HTMLParagraphProps) => (
    <StyledParagraph
      $sizeVariant={size}
      $colorVariant={color}
      $weight={weight}
      $textAlign={textAlign}
      $flexAlignCenter={flexAlignCenter}
      dangerouslySetInnerHTML={{ __html: dangerousHTML }}
      {...props}
    />
  ),
);

export { HTMLParagraph };
